import {inject, InputSignal}  from '@angular/core';
import {CrudRecordIntf}       from "@djsharkk/logr-types";
import {DataFactoryService}   from '../../../../logr-services/data/data-factory.service';
import {FirebaseToolsService} from '../../../../logr-services/firebase/firebase-tools.service';

export abstract class DialogEditBase<T extends CrudRecordIntf> {
	svcFirebaseTools = inject(FirebaseToolsService)
	svcDataFactory = inject(DataFactoryService)

	abstract rec: InputSignal<T>;

	record?: T;


}
